/**
 * Context help for the original's commands.
 *
 * GENERATED by tools/extract-help.ts from CIRCAD's own OGcontext.pth. Do not
 * edit by hand — re-run the extractor. The words are the original authors',
 * which is the point: they describe what each command is *for*, and nobody
 * writing this from the outside would put it the same way.
 *
 * 237 topics, keyed by the same two-character command codes the
 * menu tree uses.
 */

export interface HelpTopic {
  /** Two-character command code, e.g. `FO` for File Open. */
  code: string;
  title: string;
  /** One line, for a tooltip. */
  tip: string;
  /** The full text, in paragraphs. */
  body: string;
}

export const HELP_TOPICS: HelpTopic[] = [
  {
    code: "?A",
    title: "About",
    tip: "Displays a dialog box containing copyright and corporate information.",
    body: "Displays a dialog box containing copyright and corporate information.",
  },
  {
    code: "?F",
    title: "SirCAD Features",
    tip: "Displays a dialog box containing a somewhat boastful listing of SirCAD's key features.",
    body: "Displays a dialog box containing a somewhat boastful listing of SirCAD's key features.",
  },
  {
    code: "?H",
    title: "Help",
    tip: "Invokes your web browser to give full access to SirCAD's online help system.",
    body: "Invokes your web browser to give full access to SirCAD's online help system.",
  },
  {
    code: "?O",
    title: "Brief Overview",
    tip: "Displays a dialog box containing a short summary of SirCAD's overall functionality.",
    body: "Displays a dialog box containing a short summary of SirCAD's overall functionality.",
  },
  {
    code: "?P",
    title: "Tips",
    tip: "Invokes your web browser to access a set of helpful tips and dirty tricks.",
    body: "Invokes your web browser to access a set of helpful tips and dirty tricks.",
  },
  {
    code: "?R",
    title: "Support",
    tip: "Invokes your mail client to send a message to SirCAD support.",
    body: "Invokes your mail client to send a message to SirCAD support.",
  },
  {
    code: "?T",
    title: "How To",
    tip: "Invokes your web browser to access detailed step-by-step instructions which will guide you along as you climb the \"learning curve\" on…",
    body: "Invokes your web browser to access detailed step-by-step instructions which will guide you along as you climb the \"learning curve\" on your way to becoming a skilled layout technician.",
  },
  {
    code: "?U",
    title: "Updates",
    tip: "Invokes your web browser to access the SirCAD updates page.",
    body: "Invokes your web browser to access the SirCAD updates page.",
  },
  {
    code: "?W",
    title: "Website",
    tip: "Invokes your web browser to access the SirCAD home page.",
    body: "Invokes your web browser to access the SirCAD home page.",
  },
  {
    code: "Ba",
    title: "Mark All Text",
    tip: "Marks a block that select the entire data file.",
    body: "Marks a block that select the entire data file.\n\n This function is available by simply typing <Ctl-A> on the keyboard.",
  },
  {
    code: "BA",
    title: "Tear Drop",
    tip: "Scan the contained portion of the data file to locate pads with signal lines emanating from them.",
    body: "This function will scan the contained portion of the data file to locate pads with signal lines emanating from them.  A small triangle will be added to each connection such that the line will appear to flare out just as it approaches the pad.  This is often times desirable with thin signal tracks to prevent over etching and track failure at the pad to track interface.\n\n These teardrops are easily removed by using the Delete Tear Drops function.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "Bb",
    title: "Mark Bytes of Text",
    tip: "Starts or stops the marking of a block that will select all characters and controls.",
    body: "Starts or stops the marking of a block that will select all characters and controls.\n\n This function is available by simply typing <Alt-A> on the keyboard.",
  },
  {
    code: "BB",
    title: "Build Component",
    tip: "Consolidate the data file elements within a block containment region into a single entity known as a \"component\".",
    body: "This function is used to consolidate the data file elements within a block containment region into a single entity known as a \"component\".  All contained components will automatically be dissolved in the process.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "Bc",
    title: "Mark a Column of Text",
    tip: "Starts or stops the marking of a block that will select a rectangular column of characters.",
    body: "Starts or stops the marking of a block that will select a rectangular column of characters.  Trailing white space on each data line will be discarded.\n\n This function is available by simply typing <Alt-C> on the keyboard.",
  },
  {
    code: "BC",
    title: "Copy",
    tip: "Duplicate the data file elements within the block containment region to a new position on the same data file.",
    body: "This function is used to duplicate the data file elements within the block containment region to a new position on the same data file.  To copy items into a different data file, you must use the clipboard copy/paste functions below.\n\n When invoked, a replicate copy of all contained elements will be created and attached to the cursor.  You will then be free to move the attached items to any desired XY location where you may set them down simply by pressing <left mouse> or <Enter> on the keyboard.  Pressing <right mouse> or <Escape> will release and delete the grabbed items.  The original file elements will not be affected by this operation.\n\n Simple vertical, horizontal, or diagonal movement may be achieved by activating one of the \"ortho\" modes once the replicate items have been created.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "BD",
    title: "Delete Inside",
    tip: "Delete all data file elements within the block containment region and remove them from the current data file.",
    body: "This function will delete all data file elements within the block containment region and remove them from the current data file.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "Be",
    title: "Paste from Clipboard",
    tip: "Inserts clipboard data at the current cursor.",
    body: "Inserts clipboard data at the current cursor.\n\n This function is available by simply typing <insert> on the numeric keypad.",
  },
  {
    code: "BE",
    title: "Release",
    tip: "Release and un-define the containment region and thus disable block processing.",
    body: "This function will release and un-define the containment region and thus disable block processing.",
  },
  {
    code: "BF",
    title: "Flood Fill",
    tip: "Outline a set of tracks and pads, and then to fill the remainder of the region with lines.",
    body: "The Flood Fill function is used to outline a set of tracks and pads, and then to fill the remainder of the region with lines.  This is useful for certain types of ground plane areas.  When you select this function, a dialog box will appear with an assortment of parameters to control the flood fill operation.\n\n The flooding of an entire circuit board will often create isolated pockets of copper that have no physical connection to any grounded tracks or pads. These areas are easily removed by using the Delete Iso Islands function.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "Bg",
    title: "Mark a Source Code Group",
    tip: "Searches and marks (highlights) the code group surrounding the cursor.",
    body: "Searches and marks (highlights) the code group surrounding the cursor.\n\n Within a C++ source file, groups are delineated by paired opening and closing parenthesis or braces.  In HTML files, groups are delineated by matched sets of tags (such as <font> and </font>).\n\n This function is available by simply typing <F8> on the keyboard.",
  },
  {
    code: "BG",
    title: "Rectangle",
    tip: "Define a rectangular containment region for the other block functions to act upon.",
    body: "This function is used to define a rectangular containment region for the other block functions to act upon.  Once defined, the block may be further constrained by specifying a restricted set of source layers.\n\n A rectangular block is defined by selecting two corner points and a source reference point.",
  },
  {
    code: "BI",
    title: "Polyline",
    tip: "Define the boundaries of an irregularly shaped containment block.",
    body: "This function is used to define the boundaries of an irregularly shaped containment block.  Once defined, the block may be further constrained by specifying a limited set of source layers.\n\n A polyline block is defined by selecting three or more vertex points and a source reference point.",
  },
  {
    code: "Bl",
    title: "Mark Lines of Text",
    tip: "Starts or stops the marking of a block that will select a entire lines of text.",
    body: "Starts or stops the marking of a block that will select a entire lines of text.\n\n This function is available by simply typing <Alt-L> on the keyboard.",
  },
  {
    code: "BL",
    title: "Layers",
    tip: "Set a restricted set of source layers for the various block functions to act upon.",
    body: "The Block Layers function is used to set a restricted set of source layers for the various block functions to act upon.  When you select this function, a dialog box will appear which will display a list of the current layer selection and allow you modify that set.\n\n A block must be defined before this function is operational.  Initially, the block will have all layers enabled.",
  },
  {
    code: "BM",
    title: "Move",
    tip: "Relocate the data file elements within the block containment region to a new position on the same data file.",
    body: "This function is used to relocate the data file elements within the block containment region to a new position on the same data file.\n\n When invoked, the graphics cursor will jump to the block's source reference point and all contained elements will be grabbed and attached to the cursor. You will then be free to move the attached items to a new XY location where you may set them down simply by pressing <left mouse> or <Enter> on the keyboard.  Pressing <right mouse> or <Escape> will release the grabbed items, returning them to their original positions in the data file.\n\n Simple vertical, horizontal, or diagonal movement may be achieved by activating one of the \"ortho\" modes once the items have been grabbed.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "BN",
    title: "Nest Component",
    tip: "Consolidate all components and free data elements within a block containment region into a single \"super-component\".",
    body: "This function is used to consolidate all components and free data elements within a block containment region into a single \"super-component\".  Nested components are of little utility and should not be used on a normal circuit board.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "BO",
    title: "Isolation Output",
    tip: "Create a set of files to be used to drill, mill, and route a circuit board on a prototype board machine.",
    body: "The Isolation Output function is used to create a set of files to be used to drill, mill, and route a circuit board on a prototype board machine. The file must first be processed by the Track Isolation function (above) before this function can be used.  When you select this function, a dialog box will appear with an assortment of parameters to control the generation of the output data files.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "Bp",
    title: "Point Plotting",
    tip: "Plots a set of points onto a graph.",
    body: "Plots a set of points onto a graph.\n\n This function will invoke a dialog box that will draw a graph from the set of points included in the marked data block.  Additional instructions will be available from the plotting control box.  Only data contained within the block will processed.",
  },
  {
    code: "BP",
    title: "Paste from Clipboard",
    tip: "Paste previously copied clipboard items into the current data file.",
    body: "This function will paste previously copied clipboard items into the current data file.  The objects to be pasted must have been copied to the clipboard by one of the SirCAD clipboard functions.  Only graphics objects can be pasted into a graphics data file.\n\n This function is equivalent to the Paste from Clipboard entry found in the \"Edit\" menu.\n\n Clipboard data must be available before this function will be operational.",
  },
  {
    code: "BQ",
    title: "Isolation Sequencing",
    tip: "Adjust or modify the routing order of the isolation lines created by the Track Isolation function (above).",
    body: "The Isolation Sequencing function is used to adjust or modify the routing order of the isolation lines created by the Track Isolation function (above). When you select this function, a dialog box will appear with an assortment of parameters to control the order of the isolation data.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "BR",
    title: "Rotate/Scale/Mirror",
    tip: "Invoke a dialog box with entry fields for rotation angle, scaling factor, and mirroring on X and Y.",
    body: "This function will invoke a dialog box with entry fields for rotation angle, scaling factor, and mirroring on X and Y.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "Bs",
    title: "Sort on a column",
    tip: "Sort a set of lines as defined by columnar block.",
    body: "Sort a set of lines as defined by columnar block.\n\n To use this function, a column of text must be marked by using the \"Select Column\" function listed above.  Only lines contained vertically within the block will be sorted, and only columns of text contained horizontally within the block will be scrutinized for purposes of re-ordering the lines.\n\n This function is available by simply typing <Alt-Z> on the keyboard.",
  },
  {
    code: "BS",
    title: "Delete Outside",
    tip: "Delete all data file elements that are not within the block containment region and remove them from the current data file.",
    body: "This function will delete all data file elements that are not within the block containment region and remove them from the current data file.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "Bt",
    title: "Cut to Clipboard",
    tip: "Copies a marked block to the clipboard and deletes it from the data file.",
    body: "Copies a marked block to the clipboard and deletes it from the data file. If no block has been defined, the current line will be cut instead.\n\n This function is available by simply typing <minus> on the numeric keypad.",
  },
  {
    code: "BT",
    title: "Track Isolation",
    tip: "Construct a set of outlines around the tracks and pads on a PCB file, thus isolating them from one another, and from the remaining sea…",
    body: "The Track Isolation function is used to construct a set of outlines around the tracks and pads on a PCB file, thus isolating them from one another, and from the remaining sea of copper on the blank board.  Optionally, you may also construct a set of flood lines to clear out these areas of unwanted copper.  When you select this function, a dialog box will appear with all parameters needed to produce a set of isolation lines.\n\n Once isolated and checked for correctness, the PCB data may then be converted to mill, drill, and route files by using the Isolation Output function below.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "By",
    title: "Copy to Clipboard",
    tip: "Copies a marked block to the clipboard.",
    body: "Copies a marked block to the clipboard.  If no block has been defined, the current line will be copied instead.\n\n This function is available by simply typing <plus> on the numeric keypad.",
  },
  {
    code: "BY",
    title: "Copy to Clipboard",
    tip: "Replicate the data file elements within the block containment region onto the system clipboard for placement at a new position on the…",
    body: "This function is used to replicate the data file elements within the block containment region onto the system clipboard for placement at a new position on the same data file or in a different data file.  When selected, a short \"peep\" will be issued as an audio confirmation message.\n\n A block must be defined before this function will be operational.",
  },
  {
    code: "DA",
    title: "Delete Arc",
    tip: "Remove an existing arc, circle, ellipse, bulged line, or spiral.",
    body: "The Delete Arc/spiral function will remove an existing arc, circle, ellipse, bulged line, or spiral.  To delete a curve, you must first position the cursor somewhere along the circumference line of the desired element and then press <left mouse> or <Enter>.  In the event of overlapping targets, items on the current layer are given preference over those on other layers, and smaller elements are given preference over larger ones.\n\n Curves contained within components are accessible only from the proper layer.",
  },
  {
    code: "DC",
    title: "Delete Component",
    tip: "Remove an entire component.",
    body: "The Delete Component function will remove an entire component.  Attached signal tracks will remain in place.  To delete a component, you must first position the cursor somewhere within the interior of the desired component and then press <left mouse> or <Enter>.\n\n In the event of overlapping target components, smaller components are given preference over larger ones, and surface mount components on the current layer are given preference over all others.",
  },
  {
    code: "DE",
    title: "Delete Vertex",
    tip: "Remove a vertex from the interior of an existing multi-line track.",
    body: "The Delete Vertex function is used to remove a vertex from the interior of an existing multi-line track.  To delete a vertex, you must first position the cursor on or very near the desired vertex and then press <left mouse> or <Enter>.  When working in a densely populated area, it is useful to pre-select the desired target layer.\n\n Vertices of lines contained within components cannot be deleted with this function.",
  },
  {
    code: "DF",
    title: "Delete Filled Solid",
    tip: "Remove a filled region.",
    body: "The Delete Filled Solid function will remove a filled region.  To delete a solid, you must first position the cursor somewhere within the interior of the desired region and then press <left mouse> or <Enter>.\n\n In the event of overlapping targets, solids on the on the current layer are given preference over those on other layers, and smaller areas are given preference over larger ones.",
  },
  {
    code: "DG",
    title: "Delete Grabbed Items",
    tip: "Delete all items that have been grabbed and are attached to the mobile graphics cursor.",
    body: "The Delete Grabbed Items function will delete all items that have been grabbed and are attached to the mobile graphics cursor.",
  },
  {
    code: "DH",
    title: "Delete Hilighted Items",
    tip: "Delete all elements that are currently hilighted.",
    body: "The Delete Hilighted Items function will delete all elements that are currently hilighted.",
  },
  {
    code: "DI",
    title: "Delete Iso-islands",
    tip: "Delete isolated lines and arcs from all copper layers.",
    body: "The Delete Iso-islands function will delete isolated lines and arcs from all copper layers.  An isolated island is defined as a section of copper that is not attached to a pad or via.\n\n Isolated copper islands are created in large numbers by the copper flood functions.",
  },
  {
    code: "DL",
    title: "Delete Line",
    tip: "Remove a single line segment.",
    body: "The Delete Line function is used to remove a single line segment.  To delete a line segment, you must first position the cursor somewhere within the interior of the desired line segment and then press <left mouse> or <Enter>.  In the event of multiple targets, lines on the current layer are given preference over those on other layers, and shorter lines are given preference over longer ones.\n\n Lines contained within components are accessible only from the proper layer.",
  },
  {
    code: "DM",
    title: "Delete Multi-line",
    tip: "Remove an entire signal track.",
    body: "The Delete Multi-line function is used to remove an entire signal track. To delete a track, you must first position the cursor somewhere within the interior of one of the segments of the desired track and then press <left mouse> or <Enter>.  The target line segment is first deleted, then, recursively, each line segment, free pad, or via coincident with the deleted line segment's end-points.  The process will terminate if a component pad encountered.\n\n Lines contained within components are accessible only from the proper layer.",
  },
  {
    code: "DO",
    title: "Delete Flood Lines",
    tip: "Delete all lines and arcs that have been created by either Block Flood Fill function or the Block Track Isolation function.",
    body: "The Delete Flood Lines function will delete all lines and arcs that have been created by either Block Flood Fill function or the Block Track Isolation function.",
  },
  {
    code: "DP",
    title: "Delete Pad/Via",
    tip: "Remove a pad, a via, or a mounting hole.",
    body: "The Delete Pad/Via function will remove a pad, a via, or a mounting hole. To delete a pad, you must first position the cursor somewhere within the interior of the desired element and then press <left mouse> or <Enter>.\n\n Pads contained within components are accessible only from the proper layer.",
  },
  {
    code: "DR",
    title: "Delete Teardrops",
    tip: "Delete the teardrops from all copper layers.",
    body: "The Delete Teardrops function will delete the teardrops from all copper layers.  A teardrop is defined as a triangular filled region along a track making a chamfered shape just as it enters a pad.\n\n Teardrops are created by the Block TearDrop function.",
  },
  {
    code: "DT",
    title: "Delete: Text",
    tip: "Remove an ASCII text string.",
    body: "The Delete Text function will remove an ASCII text string.  To delete a piece of text, you must first position the cursor somewhere within the interior of the desired text data string and then press <left mouse> or <Enter>.\n\n In the event of overlapping targets, items on the current layer or items not owned by a component are given preference over others.",
  },
  {
    code: "E-",
    title: "Dilation",
    tip: "Apply a \"Dilation\" convolution to the selected pixel array.",
    body: "This function will apply a \"Dilation\" convolution to the selected pixel array.  The dilation algorithm replaces each pixel with the maximum value of the nine pixel matrix centered on that pixel.  This has the effect of expanding the bright areas and contract the darker areas.\n\n The source images encoded in 8-bit palette format cannot be processed by this function.",
  },
  {
    code: "E,",
    title: "Erosion",
    tip: "Apply an \"Erosion\" convolution to the selected pixel array.",
    body: "This function will apply an \"Erosion\" convolution to the selected pixel array.  The erosion algorithm replaces each pixel with the minimum value of the nine pixel matrix centered on that pixel.  This has the effect of contracting the bright areas and expanding the darker areas.\n\n The source images encoded in 8-bit palette format cannot be processed by this function.",
  },
  {
    code: "E;",
    title: "Grid Align Text",
    tip: "Move all text strings to the nearest grid point.",
    body: "This function will move all text strings to the nearest grid point.",
  },
  {
    code: "E:",
    title: "Grid Align Components",
    tip: "Move all components to the nearest grid point.",
    body: "This function will move all components to the nearest grid point.",
  },
  {
    code: "E.",
    title: "Median",
    tip: "Apply a \"Median\" convolution to the selected pixel array.",
    body: "This function will apply a \"Median\" convolution to the selected pixel array.  The median algorithm replaces each pixel with the average value of the nine pixel matrix centered on that pixel.  This has the effect of smoothing a noisy picture.\n\n The source images encoded in 8-bit palette format cannot be processed by this function.",
  },
  {
    code: "E/",
    title: "Un-Do",
    tip: "Flip the current pixel array with the alternate array, effectively \"un-doing\" the previous convolution function.",
    body: "This function will flip the current pixel array with the alternate array, effectively \"un-doing\" the previous convolution function.\n\n The option is available only immediately following a convolution operation.",
  },
  {
    code: "E<",
    title: "Pad Align Tracks",
    tip: "Move all track endpoints to the center of their pad.",
    body: "This function will move all track endpoints to the center of their pad.",
  },
  {
    code: "E=",
    title: "Center SMT Insertion Points",
    tip: "Move the insertion point of all SMT component to the center of the part.",
    body: "This function will move the insertion point of all SMT component to the center of the part.",
  },
  {
    code: "E0",
    title: "Edit Pixel Array",
    tip: "A persistent dialog box (a \"modeless\" dialog box in Windows jargon) that provides several pixel array editing functions.",
    body: "This function invokes a persistent dialog box (a \"modeless\" dialog box in Windows jargon) that provides several pixel array editing functions.\n\n Detailed help is available for all items in the dialog box.",
  },
  {
    code: "E1",
    title: "Move without Scaling",
    tip: "May be used to move a pixel array without rotation, scaling, or axis distortions.",
    body: "This function may be used to move a pixel array without rotation, scaling, or axis distortions.\n\n Only a single pair of points need be specified for this operation.",
  },
  {
    code: "E2",
    title: "Rotation with Scaling",
    tip: "May be used to rotate, re-scale and re-sample a pixel array.",
    body: "This function may be used to rotate, re-scale and re-sample a pixel array.\n\n A minimum of two pairs of points are needed to define this operation.  If additional pairs of points are provided they will be fed into a least squares regression algorithm to produce a \"best fit\" set of two point pairs.",
  },
  {
    code: "E3",
    title: "Affine Transformation",
    tip: "Apply an affine translation to a pixel array.",
    body: "This function will apply an affine translation to a pixel array.  This includes rotation, scaling, shear, and relocation.  Geometrically, an affine transformation in Euclidean space preserves:\n1: The collinearity relation between points, i.e., three points which lie on a line continue to be collinear after the transformation.\n2: Ratios of distances along a line, i.e., for distinct collinear points p1, p2, p3, the ratio |p2-p1|/|p3-p2| is preserved.\n\n A minimum of three pairs of points are needed to define an affine transformation.\t If additional pairs of points are provided they will be fed into a least squares regression algorithm to produce a \"best fit\" set of three point pairs.",
  },
  {
    code: "E4",
    title: "Hyperbolic Reshaping",
    tip: "Apply a hyperbolic translation to a pixel array.",
    body: "This function will apply a hyperbolic translation to a pixel array.  Its primary purpose is to convert an arbitrary quadrilateral into a properly shaped rectangle.  Most normal photographs of a rectangular object (such as a circuit board) will suffer from an axis distortion that can be remedied with a simple hyperbolic translation.\n\n A minimum of four pairs of points are needed to define define this transformation.  If additional pairs of points are provided they will be fed into a least squares regression algorithm to produce a \"best fit\" set of four point pairs.",
  },
  {
    code: "E6",
    title: "Crop with Rotation and Resampling",
    tip: "Allow you to crop a pixel array with optional rotation and resampling.",
    body: "This function will allow you to crop a pixel array with optional rotation and resampling.\n\nMenu 0x4521 Edit Pixel Mirror X This function will flip the target pixel along the X axis (left/right).\n\nMenu 0x4522 Edit Pixel Mirror Y This function will flip the target pixel along the Y axis (top/bottom).\n\nMenu 0x4523 Edit Pixel Array Rotate CCW This function will rotate the target pixel array by 90° (anti-clockwise).\n\nMenu 0x4524 Edit Pixel Array Rotate CW This function will rotate the target pixel array by 90° (clockwise).\n\nMenu 0x4525 Edit Pixel Array Rotate Upside Down This function will rotate the target pixel array by 180° (upside down).",
  },
  {
    code: "E7",
    title: "Pixel Array Stackup",
    tip: "May be used to re-sequence the logical stack-up of multiple pixel arrays.",
    body: "This function may be used to re-sequence the logical stack-up of multiple pixel arrays.  You may step amongst them by using the period and comma keys.",
  },
  {
    code: "E9",
    title: "Rectangularization",
    tip: "Rectangularize a selected portion of a pixel array.",
    body: "This function will rectangularize a selected portion of a pixel array.  Its primary purpose is to \"square-up\" a crooked or distorted image of a PCB to prepare it for reverse engineering.  After entering the size and resolution of the target rectangle, you will be prompted to select four points on the source image that are to be mapped to the target rectangle. These points should be either the four corner mounting holes or the four outside corners of the PCB.\n\n The actual image translation is performed by the same algorithm as the \"Hyperbolic Reshaping\" selection above.",
  },
  {
    code: "Ea",
    title: "File Align",
    tip: "Vertically aligns the cursor position in two text data files.",
    body: "Vertically aligns the cursor position in two text data files.  The files to be aligned must be in side-by-side sibling windows.  This can be achieved by selecting \"Dual L/R Screens\" from the Setup Page menu.\n\n This function is available by simply typing <Shift-F4> on the keyboard.",
  },
  {
    code: "EA",
    title: "Edit Arc",
    tip: "Modify the parametric values of a curved element such as a bulged line, an arc, a circle, an ellipse, or a spiral.",
    body: "The Edit Arc function is used to modify the parametric values of a curved element such as a bulged line, an arc, a circle, an ellipse, or a spiral.\n\n To edit a curved element, you must first position the cursor somewhere along the visible line of the desired element and then press <left mouse> or <Enter>.  A dialog box will appear listing the selected element's parameters along with several global editing options.  In the event of overlapping targets, curves on the current layer are given preference over those on other layers, and smaller curves are given preference over larger ones.\n\n Items contained within components are accessible only from the proper layer.",
  },
  {
    code: "Eb",
    title: "Goto End of Group",
    tip: "Jumps the cursor to the last character in the current code group.",
    body: "Jumps the cursor to the last character in the current code group.\n\n Within a C++ source file, groups are delineated by paired opening and closing parenthesis or braces.  In HTML files, groups are delineated by matched sets of tags (such as <font> and </font>).\n\n If the cursor is already on the last character of a group, the cursor will jump to the last character of the next higher group.\n\n This function is available by simply typing <F7> on the keyboard.",
  },
  {
    code: "EB",
    title: "Paste from Clipboard",
    tip: "Paste previously copied clipboard items into the current data file.",
    body: "This function will paste previously copied clipboard items into the current data file.  The objects to be pasted must have been copied to the clipboard by one of the SirCAD clipboard functions.  Only graphics objects can be pasted into a graphics data file.\n\n This function is equivalent to the Paste from Clipboard entry found in the \"Block\" menu.\n\n Clipboard data must be available before this function will be operational.",
  },
  {
    code: "Ec",
    title: "Calculator",
    tip: "Invokes a simple calculator for numeric processing.",
    body: "Invokes a simple calculator for numeric processing.\n\n The calculator is more useful when called interactively by typing <Ctl-Enter>, <Alt-Enter>, or <Shift-Enter> on the numeric keypad.  When so invoked, the numeric value under the cursor will be copied into the calculator's accumulator.  Arithmetic computations may then be performed upon this number.  The original source number will be replaced by the final accumulator value when the <Enter> key is pressed.\n\n Alt-Enter:  Capture/replace an unsigned integer.\nCtl-Enter:  Capture/replace the signed decimal [fraction].\nShift-Enter:  No capture, just insert final result.\n\n When called from within a keystroke macro, the calculator may be used to implement simple numeric processing operations.",
  },
  {
    code: "EC",
    title: "Edit Components",
    tip: "Invoke a dialog box listing all components in the data file with the selected component's parameters highlighted.",
    body: "The Edit Components function will invoke a dialog box listing all components in the data file with the selected component's parameters highlighted.",
  },
  {
    code: "ED",
    title: "GIS Data Base",
    tip: "Invokes a persistent dialog box (a \"modeless\" dialog box in Windows jargon) that displays an array of data base parameters.",
    body: "Invokes a persistent dialog box (a \"modeless\" dialog box in Windows jargon) that displays an array of data base parameters.\n\n Once invoked, simply hovering the cursor over a target object will display its data base parameters.",
  },
  {
    code: "Ee",
    title: "Goto End",
    tip: "Jumps the cursor to the last character of the last line of the file.",
    body: "Jumps the cursor to the last character of the last line of the file.\n\n This function is available by simply typing <End> on the keyboard three times consecutively.  The first time the <End> key is pressed, the cursor will jump to the last character on the current line.  If the <End> key is pressed again with no intervening keys, the cursor will jump to the last line on the current page.  When the <End> key is pressed for the third time, the cursor will then jump to the end of the file.",
  },
  {
    code: "EE",
    title: "Sequence Query",
    tip: "Invokes a persistent dialog box (a \"modeless\" dialog box in Windows jargon) that will display an array of item parameters.",
    body: "Invokes a persistent dialog box (a \"modeless\" dialog box in Windows jargon) that will display an array of item parameters.  The various types of objects to be processed (lines, pads, etc.) are individually selectable from the Query Items dialog box.\n\n Once invoked, simply hovering the cursor over a target object will display its various parameters.",
  },
  {
    code: "Ef",
    title: "Find Text",
    tip: "Invokes a dialog box allowing you to enter a text string and search parameters.",
    body: "Invokes a dialog box allowing you to enter a text string and search parameters.\n\n This function is available by simply typing <F5> on the keyboard.",
  },
  {
    code: "EF",
    title: "Edit Filled Solid",
    tip: "The Edit Filled Solid function may be used to modify a filled solid by changing its parameters, or by adding, deleting, or moving one or…",
    body: "The Edit Filled Solid function may be used to modify a filled solid by changing its parameters, or by adding, deleting, or moving one or more of or its vertices.\n\n To modify the parameters of a filled solid, simply click anywhere within the interior region of a filled solid and a dialog box will appear allowing the modification of any of the several parameters defining the region.\n\n To modify the shape of a filled solid, you must first \"grab\" the desired solid and then enter the key-strokes <EF>.  The filled solid will be reduced to a set of perimeter lines.  The lines may then be modified using any of the standard editing functions.\n\n To construct a filled solid, you must first \"grab\" the one of perimeter lines and then enter the key-strokes <EF>. The file will be scanned for a set of contiguous lines that define the perimeter of a closed region. The entire group of lines will then be compiled into a solidly filled area.",
  },
  {
    code: "Eg",
    title: "Goto Line",
    tip: "Jumps the cursor to a specific line number.",
    body: "Jumps the cursor to a specific line number.\n\n This function is available by simply typing <Alt-G> on the keyboard.",
  },
  {
    code: "Eh",
    title: "Goto Home",
    tip: "Jumps the cursor to the first character of the first line of the file.",
    body: "Jumps the cursor to the first character of the first line of the file.\n\n This function is available by simply typing <Home> on the keyboard three times consecutively.  The first time the <Home> key is pressed, the cursor will jump to the first character on the current line.  If the <Home> key is pressed again with no intervening keys, the cursor will jump to the first line on the current page.  When the <Home> key is pressed for the third time, the cursor will then jump to the head of the file.",
  },
  {
    code: "Ei",
    title: "HTML Image Map",
    tip: "Converts HTML image maps and area tags to graphics entities and displays the file in graphics mode.",
    body: "Converts HTML image maps and area tags to graphics entities and displays the file in graphics mode.  Existing areas may then be modified and new areas and shapes may be added to the map.  The HTLM source will be re-built when the file is returned to text mode once again.\n\n This function is available by simply typing <Ctl-T> on the keyboard.",
  },
  {
    code: "EK",
    title: "Krump Component",
    tip: "The Krump Component function may be used to modify a component by adding items to it, removing items from it, or dissolving a component…",
    body: "The Krump Component function may be used to modify a component by adding items to it, removing items from it, or dissolving a component into its constituent parts.  To dissolve a component, you must first \"grab\" the desired component and then enter the key-strokes <EK>.  A pop-up warning message will appear asking for final confirmation to the dissolution function.\n\n To add items to an existing component, you must first \"grab\" the desired item, then position the cursor somewhere within the interior of the desired target component and enter the key-strokes <EK>.  The item may then be moved to its final destination position and placed back on the screen.\n\n To remove items from an existing component, you must first \"grab\" the desired item and then position the cursor somewhere outside the confines of the original component and enter the key-strokes <EK>.  The item may then be moved to its final destination position and placed back on the screen.",
  },
  {
    code: "El",
    title: "Dbase Columnize",
    tip: "Re-spaces and aligns data base text lines into neat columns of data.",
    body: "Re-spaces and aligns data base text lines into neat columns of data.  If a column contains purely numeric data, the numbers in that column will be right justified and aligned on the radix point.  All other columns will be left justified.\n\n Data base lines must start with a vertical bar character and must have each column of data delineated with a vertical bar.\n\n This function is available by simply typing <Alt-H> on the keyboard.",
  },
  {
    code: "EL",
    title: "Edit Line",
    tip: "Modify an existing line segment's width, color, drawing style, signal name, or layer affiliation.",
    body: "The Edit Line function is used to modify an existing line segment's width, color, drawing style, signal name, or layer affiliation.\n\n To edit a line segment, you must first position the cursor somewhere within the interior of the desired line segment and then press <left mouse> or <Enter>.  A dialog box will appear with the selected line's parameters along with several global editing options.  In the event of multiple targets, lines on the current layer are given preference over those on other layers, and shorter lines are given preference over longer ones.\n\n Lines contained within components are accessible only from the proper layer.",
  },
  {
    code: "Em",
    title: "HTML Image Un-Map",
    tip: "Reverts the HTML image maps from graphics mode back to text format.",
    body: "Reverts the HTML image maps from graphics mode back to text format.  All maps, area tags, and shapes will be re-built into the source data file.\n\n This function is available by simply typing <Ctl-T> on the keyboard.",
  },
  {
    code: "EM",
    title: "Resequence Components",
    tip: "Re-sequence number the components in a single data file or in an entire project.",
    body: "This function is used to re-sequence number the components in a single data file or in an entire project.  To access the project mode, this function must be invoke from schematic sheet one.",
  },
  {
    code: "En",
    title: "Find Next Text",
    tip: "Searches for the next instance of the same text string using the same search parameters.",
    body: "Searches for the next instance of the same text string using the same search parameters.\n\n This function is available by simply typing <F3> on the keyboard.",
  },
  {
    code: "EN",
    title: "Edit Component",
    tip: "Invoke a dialog box listing the parameters for a single component.",
    body: "The Edit Component function will invoke a dialog box listing the parameters for a single component.",
  },
  {
    code: "Eo",
    title: "Dbase Compact",
    tip: "Deletes leading and trailing blanks from each column of data on all Dbase lines.",
    body: "Deletes leading and trailing blanks from each column of data on all Dbase lines.  The columns will typically no longer be vertically aligned, but the resulting data file will be smaller and may also be easier to parse by other data processing programs.\n\n Data base lines must start with a vertical bar character and must have each column of data delineated with a vertical bar.\n\n This function is available by simply typing <Alt-J> on the keyboard.",
  },
  {
    code: "EO",
    title: "Locate Component",
    tip: "Invoke a dialog box listing all components in the data file.",
    body: "This function will invoke a dialog box listing all components in the data file.  When you select a component from the list, the cursor will be snapped to the component's insertion point, scrolling the screen if necessary to bring the cursor into view.",
  },
  {
    code: "Ep",
    title: "File Compare",
    tip: "Performs an interpretive line-by-line comparison of two text data files.",
    body: "Performs an interpretive line-by-line comparison of two text data files. The files to be compared must be in side-by-side sibling windows.  This can be achieved by selecting \"Dual L/R Screens\" from the Setup Page menu.\n\n The current cursor position in each file determines the starting line number when the comparison is initiated.  The comparison operation starts with a simple line by line matching process till a difference is discovered.  The comparison function then enters a more complex recursive mode, looking for at least three lines in each file that match three lines in the opposite data file.  When a match is found, the lines that are different between the two files will be marked (highlighted).  The cursor position in each file will be jumped to the head of the unmatched lines and the files will be scrolled vertically such that the unmatched lines will be easily recognizable.\n\n Subsequent comparisons will \"hop over\" the unmatched lines (that have been marked) to locate the next unmatched set of lines.\n\n This function is available by simply typing <F4> on the keyboard.",
  },
  {
    code: "EP",
    title: "Edit Pad/Via",
    tip: "Modify a pad, a via, or a mounting hole.",
    body: "The Edit Pad/Via function is used to modify a pad, a via, or a mounting hole.\n\n To edit a pad, you must first position the cursor somewhere within the interior of the desired element and then press <left mouse> or <Enter>. A dialog box will appear with the selected pad's parameters along with several global editing options.\n\n In the event of overlapping targets, pads on the current layer or pads not owned by a component are given preference.",
  },
  {
    code: "EQ",
    title: "Item Query",
    tip: "Invokes a persistent dialog box (a \"modeless\" dialog box in Windows jargon) that will display an array of item parameters.",
    body: "Invokes a persistent dialog box (a \"modeless\" dialog box in Windows jargon) that will display an array of item parameters.  The various types of objects to be processed (lines, pads, etc.) are individually selectable from the Query Items dialog box.\n\n Once invoked, simply hovering the cursor over a target object will display its various parameters.",
  },
  {
    code: "Er",
    title: "Replace Text",
    tip: "Invokes a dialog box allowing you to enter a text string and search parameters along with a replacement text string.",
    body: "Invokes a dialog box allowing you to enter a text string and search parameters along with a replacement text string.\n\n This function is available by simply typing <F6> on the keyboard.",
  },
  {
    code: "ES",
    title: "Item Snap",
    tip: "Move the cursor to the closest nearby item.",
    body: "This function will move the cursor to the closest nearby item.",
  },
  {
    code: "Et",
    title: "Goto Top of Group",
    tip: "Jumps the cursor to the first character in the current code group.",
    body: "Jumps the cursor to the first character in the current code group.\n\n Within a C++ source file, groups are delineated by paired opening and closing parenthesis or braces.  In HTML files, groups are delineated by matched sets of tags (such as <font> and </font>).\n\n If the cursor is already on the first character of a group, the cursor will jump to the first character of the next higher group.\n\n This function is available by simply typing <Shift-F7> on the keyboard.",
  },
  {
    code: "ET",
    title: "Edit Text String",
    tip: "The Edit Text String function uses the graphics editor to modify the ASCII data portion of a text string.",
    body: "The Edit Text String function uses the graphics editor to modify the ASCII data portion of a text string.  No dialog boxes will be invoked.\n\n To edit a text string, you must first position the cursor somewhere within the interior of the desired text string and then press <left mouse> or <Enter>.\n\n In the event of overlapping targets, items on the current layer or items not owned by a component are given preference.\n\n Note: If a single text string is attached to the cursor at the time of invocation of this function, that text string will be dissolved into its constituent line and arc sub-elements.  This process is \"Un-Do-able\" but not reversible.",
  },
  {
    code: "EU",
    title: "Quick Zoom",
    tip: "Activate or deactivate the Quick Zoom dialog box.",
    body: "This function will activate or deactivate the Quick Zoom dialog box.",
  },
  {
    code: "Ev",
    title: "Graphics View",
    tip: "Reverts the display to graphics mode from diagnostic text mode.",
    body: "Reverts the display to graphics mode from diagnostic text mode.\n\n This function is available by simply typing <Ctl-T> on the keyboard.",
  },
  {
    code: "EV",
    title: "Text View",
    tip: "Converts the display to diagnostic text mode.",
    body: "Converts the display to diagnostic text mode.  All entities will be shown in format that mimics the external form that is written to disk. The file will not be editable when in this mode.\n\n This function is available by simply typing <Ctl-T> on the keyboard.",
  },
  {
    code: "Ex",
    title: "Shell Execute",
    tip: "Passes the current file to an external data processing program.",
    body: "Passes the current file to an external data processing program.\n\n The file name suffix is examined and used to extract a data processing program name and a command line from the system registry.  The command line is interpreted and the resulting information is passed to the windows \"ShellExecute\" function.  The various file associations and their corresponding command lines may be accessed for modification under the Setup menu.\n\n This function is available by simply typing <F9> on the keyboard.",
  },
  {
    code: "EX",
    title: "Edit Text Parameters",
    tip: "Modify the parametric portion of a text string.",
    body: "The Edit Text Parameters function is used to modify the parametric portion of a text string.\n\n To edit a text string, you must first position the cursor somewhere within the interior of the desired text string and then press <left mouse> or <Enter>.  A dialog box will appear with the selected text string's parameters along with several global editing options.\n\n In the event of overlapping targets, items on the current layer or items not owned by a component are given preference.",
  },
  {
    code: "EY",
    title: "Copy to Clipboard",
    tip: "Replicate a single data file element onto the system clipboard for placement at a new position on the same data file or in a different…",
    body: "This function is used to replicate a single data file element onto the system clipboard for placement at a new position on the same data file or in a different data file.  Once invoked, a pop-up dialog box will appear along the bottom of the window which will allow you to choose the set of objects that may be selected by this function.  When the cursor is then moved within the window, selectable objects will be highlighted as they are encountered. When the desired object is selected, you may copy it to the clipboard by pressing <left mouse> or <Enter> on the keyboard.\n\n A short \"peep\" will be issued as an audio confirmation message.",
  },
  {
    code: "Ez",
    title: "Multi-Dbase Columnize",
    tip: "Re-spaces and aligns data base text lines into neat columns of data.",
    body: "Re-spaces and aligns data base text lines into neat columns of data. If a column contains purely numeric data, the numbers in that column will be right justified and aligned on the radix point.  All other columns will be left justified.\n\n Each group of Dbase lines will be individually aligned to its own set of maximum column widths.  Dbase groups must be separated from one another by one or more non-Dbase lines.\n\n Data base lines must start with a vertical bar character and must have each column of data delineated with a vertical bar.\n\n This function is available by simply typing <Alt-K> on the keyboard.",
  },
  {
    code: "F?",
    title: "Purge All Files",
    tip: "Remove all data file names from the above list.",
    body: "Remove all data file names from the above list.",
  },
  {
    code: "F>",
    title: "Purge Old Files",
    tip: "Purge non-existing data files from the above list.",
    body: "Purge non-existing data files from the above list.",
  },
  {
    code: "F0",
    title: "File Recall",
    tip: "Open this data file.",
    body: "Open this data file.",
  },
  {
    code: "F1",
    title: "File Recall",
    tip: "Open this data file.",
    body: "Open this data file.",
  },
  {
    code: "F2",
    title: "File Recall",
    tip: "Open this data file.",
    body: "Open this data file.",
  },
  {
    code: "F3",
    title: "File Recall",
    tip: "Open this data file.",
    body: "Open this data file.",
  },
  {
    code: "F4",
    title: "File Recall",
    tip: "Open this data file.",
    body: "Open this data file.",
  },
  {
    code: "F5",
    title: "File Recall",
    tip: "Open this data file.",
    body: "Open this data file.",
  },
  {
    code: "F6",
    title: "File Recall",
    tip: "Open this data file.",
    body: "Open this data file.",
  },
  {
    code: "F7",
    title: "File Recall",
    tip: "Open this data file.",
    body: "Open this data file.",
  },
  {
    code: "F8",
    title: "File Recall",
    tip: "Open this data file.",
    body: "Open this data file.",
  },
  {
    code: "F9",
    title: "File Recall",
    tip: "Open this data file.",
    body: "Open this data file.",
  },
  {
    code: "FA",
    title: "Save As...",
    tip: "Invoke a dialog box allowing you to write the current file with a new name or in a different format.",
    body: "This function will invoke a dialog box allowing you to write the current file with a new name or in a different format.",
  },
  {
    code: "FB",
    title: "File BOM Out",
    tip: "Create a Bill Of Materials from the current file.",
    body: "This function will create a Bill Of Materials from the current file.",
  },
  {
    code: "FC",
    title: "File Close",
    tip: "Close the current data file and remove its name from the tab bar.",
    body: "This function will close the current data file and remove its name from the tab bar.  If the file has been modified, you will be given the option to save the file before closing.",
  },
  {
    code: "FD",
    title: "File Load",
    tip: "Open a pixel array or a Gerber plot and add its data to the current file.",
    body: "This function will open a pixel array or a Gerber plot and add its data to the current file.",
  },
  {
    code: "FE",
    title: "File Erase",
    tip: "Close the current file and erase it from disk.",
    body: "The function will close the current file and erase it from disk.  There will be an additional warning message before the file is deleted.",
  },
  {
    code: "FF",
    title: "Save Modified Files",
    tip: "Save all modified files to disk.",
    body: "This function will save all modified files to disk.",
  },
  {
    code: "Fg",
    title: "Graphics File",
    tip: "Create a new graphics data file within this window.",
    body: "This function will create a new graphics data file within this window. A dialog box will be invoked with detailed selections for each specific type of graphics file.  Pre-established template files are used to create the basic set of data fields needed for these complex graphics files.",
  },
  {
    code: "FG",
    title: "File Gerber",
    tip: "Create a set of plot files in Gerber (RS274D) format.",
    body: "This function will create a set of plot files in Gerber (RS274D) format.",
  },
  {
    code: "Fi",
    title: "Sibling Window",
    tip: "Create a new window that is an equal partner to this window.",
    body: "This function is used to create a new window that is an equal partner to this window.  All files presently open will be available to the new window. Any files opened in the new window will available to this window as well. Sibling windows are required for all multi-file multi-window project processing.",
  },
  {
    code: "FL",
    title: "File List",
    tip: "Invoke a dialog box allowing you to select the desired file from a list of open data files.",
    body: "This function will invoke a dialog box allowing you to select the desired file from a list of open data files.",
  },
  {
    code: "FM",
    title: "Save Pixel Array",
    tip: "Save an embedded pixel array as a separate data file.",
    body: "This function allows you to save an embedded pixel array as a separate data file.",
  },
  {
    code: "FN",
    title: "File Next",
    tip: "Step to the next sequential file.",
    body: "This function will step to the next sequential file.",
  },
  {
    code: "FO",
    title: "File Open",
    tip: "A dialog box to assist you in selecting the desired data file.",
    body: "This function invokes a dialog box to assist you in selecting the desired data file.  The file will then be opened and displayed for editing.",
  },
  {
    code: "FP",
    title: "File Print",
    tip: "Print the current data file.",
    body: "This function will print the current data file.",
  },
  {
    code: "FQ",
    title: "File Quit",
    tip: "Close this window.",
    body: "Close this window.",
  },
  {
    code: "Fr",
    title: "File BOM Import",
    tip: "Import a CSV format Bill Of Materials file and apply its component parameters to the current file.",
    body: "This function will import a CSV format Bill Of Materials file and apply its component parameters to the current file.",
  },
  {
    code: "Fs",
    title: "Slave Window",
    tip: "Create a new window that is subservient to this window.",
    body: "This function will create a new window that is subservient to this window.  Opened files will not be inherited by the new window.  Slave windows are automatically created by the system for log files, Gerber output files, and interactive reports.",
  },
  {
    code: "FS",
    title: "File Save",
    tip: "Save the current file to disk.",
    body: "This function will save the current file to disk.",
  },
  {
    code: "Ft",
    title: "Text File",
    tip: "Create a new empty text data file within this window.",
    body: "This function will create a new empty text data file within this window.",
  },
  {
    code: "FT",
    title: "Total Recall",
    tip: "Invoke a dialog box containing a list of recently accessed data files.",
    body: "This function will invoke a dialog box containing a list of recently accessed data files.",
  },
  {
    code: "Fu",
    title: "Cousin Window",
    tip: "Create a new window that is logically separate from this window.",
    body: "This function is used to create a new window that is logically separate from this window.  Opened files will not be inherited by the new window.",
  },
  {
    code: "FU",
    title: "File Terminate",
    tip: "Close all SirCAD windows.",
    body: "Close all SirCAD windows.",
  },
  {
    code: "FV",
    title: "File Previous",
    tip: "Step to the previous sequential file.",
    body: "This function will step to the previous sequential file.",
  },
  {
    code: "FX",
    title: "File Exit",
    tip: "Close this set of windows.",
    body: "Close this set of windows.",
  },
  {
    code: "GA",
    title: "Grab Arc/Spiral",
    tip: "Pick up and move a single bulged line, arc, circle, ellipse, or spiral.",
    body: "The Grab Arc Edge function will pick up and move a single bulged line, arc, circle, ellipse, or spiral.  To grab a curved element, you must first position the cursor somewhere along the edge (circumference) of the desired object and then press <left mouse> or <Enter>.\n\n In the event of overlapping targets, curves on the current layer are given preference over those on other layers, and smaller elements are given preference over larger ones.\n\n Items contained within components are accessible only from the proper layer.",
  },
  {
    code: "GC",
    title: "Grab Component",
    tip: "Pick up and move a component and all line segment vertices coincident with the component's signal pads.",
    body: "The Grab Component function will pick up and move a component and all line segment vertices coincident with the component's signal pads.  To grab a component, you must first position the cursor somewhere within the interior of the desired component and then press <left mouse> or <Enter>.  The cursor will jump to the component reference point.\n\n In the event of overlapping target components, smaller components are given preference over larger ones and surface mount components on the current layer are given preference over all others.",
  },
  {
    code: "GD",
    title: "Grab Curve Endpoint",
    tip: "The Grab Arc Endpoint function can be used to graphically move either end point of a curved object such as a bulged line, an arc, or a…",
    body: "The Grab Arc Endpoint function can be used to graphically move either end point of a curved object such as a bulged line, an arc, or a spiral.  The opposite end point will not be affected.  To grab a curve's endpoint, you must first position the cursor somewhere along the edge (circumference) of the desired element and then press <left mouse> or <Enter>.  The cursor will jump to the nearer endpoint of the curve before the object is lifted from the drawing.\n\n In the event of overlapping targets, curves on the current layer are given preference over those on other layers, and smaller curves are given preference over larger ones.\n\n Items contained within components are accessible only from the proper layer.",
  },
  {
    code: "GE",
    title: "Grab Vertex",
    tip: "Pick up and move all coincident line segment end-points and vias at a an interior point of a multi-line track.",
    body: "The Grab Vertex function will pick up and move all coincident line segment end-points and vias at a an interior point of a multi-line track.  To grab a vertex, you must first position the cursor on or very nearly on the desired vertex and then press <left mouse> or <Enter>.  The cursor will jump to the precise vertex point.\n\n When working in a densely populated area, it is useful to pre-select the desired target layer.\n\n Vertices of lines contained within components are accessible only from the proper layer.",
  },
  {
    code: "GF",
    title: "Grab Filled Solid",
    tip: "Pick up and move a filled region.",
    body: "The Grab Filled Solid function will pick up and move a filled region.\n\n To grab and move a single vertex point, you must first position the cursor precisely on top of the desired vertex.  This can be easily achieved using the \"Snap Item\" function (below).  To grab an entire edge line, the cursor must be located precisely on top of the desired edge.  To grab the entire region, the cursor may be located anywhere within the interior of the region.  When the cursor is properly positioned, you must then press <left mouse> or <Enter>.\n\n In the event of overlapping targets, solids on the on the current layer are given preference over those on other layers, and smaller areas are given preference over larger ones.\n\n Once grabbed, a filled region may be converted back into its constituent line segments by invoking the \"Edit Filled Solid\" function.  The lines can then be modified by using any of the standard line editing functions.  Once the lines have been suitably re-arranged, they can be converted back into a filled region once again.",
  },
  {
    code: "GG",
    title: "Grab Curve Origin",
    tip: "Pick up and move a single bulged line, arc, circle, ellipse, or spiral.",
    body: "The Grab Arc Origin function will pick up and move a single bulged line, arc, circle, ellipse, or spiral.  To grab a curved element, you must first position the cursor somewhere along the edge (circumference) of the desired object and then press <left mouse> or <Enter>.  The cursor will jump to the center point of the curve before the object is lifted from the drawing.\n\n In the event of overlapping targets, curves on the current layer are given preference over those on other layers, and smaller curves are given preference over larger ones.\n\n Items contained within components are accessible only from the proper layer.",
  },
  {
    code: "GI",
    title: "Grab Item",
    tip: "The Grab Item function is both powerful and difficult to use.",
    body: "The Grab Item function is both powerful and difficult to use.  The current working layer must be correctly set and the cursor positioning must be absolutely accurate before this function can be used.  Any of the primitive items can be grabbed and attached to the cursor, even if they are contained within a component.  A component's insertion point is accessible from layer zero.\n\n Only a single primitive element will be grabbed, even if there are multiple targets available.  Subsequent items may be selected by simply re-invoking the grab item function without moving the graphics cursor.",
  },
  {
    code: "GL",
    title: "Grab Line",
    tip: "Pick up and move the entire body of one line segment, along with any free pads, vias, and other vertices coincident with the line…",
    body: "The Grab Line function will pick up and move the entire body of one line segment, along with any free pads, vias, and other vertices coincident with the line segment's end-points.  To grab a line segment, you must first position the cursor somewhere within the interior of the desired line segment and then press <left mouse> or <Enter>.\n\n In the event of multiple targets, lines on the current layer are given preference over those on other layers, and shorter lines are given preference over longer ones.\n\n Lines contained within components are accessible only from the proper layer.",
  },
  {
    code: "GM",
    title: "Mirror T/B",
    tip: "Flip all grabbed cursor attachments from the top side of the board to the bottom side.",
    body: "The Mirror T/B function will flip all grabbed cursor attachments from the top side of the board to the bottom side.  Top copper items will flip to bottom copper, top silk to bottom silk, and top mask to bottom mask. Physically, the part will be mirrored along the X axis so that it will be ready for placement on the opposite side of the board.  All items will remain in the ghost form until they are released by pressing <left mouse> or <Enter>.\n\n This function is available by simply typing <M> on the keyboard once an item has been grabbed.",
  },
  {
    code: "GN",
    title: "Rotate n",
    tip: "Rotate all grabbed cursor attachments by any desired angular amount.",
    body: "The Rotate n° function will rotate all grabbed cursor attachments by any desired angular amount.  When you select this function, a dialog box will appear for the entry of a rotational value.  Once this value has been entered, items attached to the cursor will be rotated (anti-clockwise) the specified number of degrees using the cursor as the center of rotation. The items will remain in the ghost form until they are released by pressing <left mouse> or <Enter>.\n\n This function is available by simply typing <A> on the keyboard once an item has been grabbed.",
  },
  {
    code: "GO",
    title: "Grab Comp Only",
    tip: "Pick up and move a component while leaving the signal tracks behind.",
    body: "The Grab Component Only function will pick up and move a component while leaving the signal tracks behind.  To grab a component, you must first position the cursor somewhere within the interior of the desired component and then press <left mouse> or <Enter>.  The cursor will jump to the component reference point.\n\n In the event of overlapping target components, smaller components are given preference over larger ones and surface mount components on the current layer are given preference over all others.",
  },
  {
    code: "GP",
    title: "Grab Pad",
    tip: "Pick up and move a single pad, via, or mounting hole.",
    body: "The Grab Pad function will pick up and move a single pad, via, or mounting hole.  To grab a pad, you must first position the cursor somewhere within the interior of the desired pad and then press <left mouse> or <Enter>. The cursor will jump to the precise center point of the target pad.\n\n Pads contained within components are accessible only from the proper layer.",
  },
  {
    code: "GR",
    title: "Rotate 90",
    tip: "Rotate all grabbed cursor attachments.",
    body: "The Rotate 90° function will rotate all grabbed cursor attachments.  Each time you invoke this function, items attached to the cursor will be rotated by 90° (anti-clockwise) using the cursor as the center of rotation.  The items will remain in the ghost form until they are released by pressing <left mouse> or <Enter>.\n\n This function is available by simply typing <R> on the keyboard once an item has been grabbed.",
  },
  {
    code: "GS",
    title: "Scale XY",
    tip: "Enlarge or contract all grabbed cursor attachments by a user specified magnification factor.",
    body: "The Scale XY function will enlarge or contract all grabbed cursor attachments by a user specified magnification factor.  When you select this function, a dialog box will appear which will allow you to enter the desired scaling factor.  The newly magnified items will remain in the ghost form until they are released by pressing <left mouse> or <Enter>.\n\n This function is available by simply typing <K> on the keyboard once an item has been grabbed.",
  },
  {
    code: "GT",
    title: "Grab Text",
    tip: "Pick up and move a single text string.",
    body: "The Grab Text function will pick up and move a single text string.  To grab a text string, you must first position the cursor somewhere within the interior of the desired text string and then press <left mouse> or <Enter>. The cursor will jump to the insertion point of the target text string.\n\n In the event of overlapping targets, items on the current layer or items not owned by a component are given preference.",
  },
  {
    code: "GV",
    title: "Grab Curve Center Point",
    tip: "The Grab Curve Center Point function can be used to graphically move the center point of a curved object such as a bulged line, an arc,…",
    body: "The Grab Curve Center Point function can be used to graphically move the center point of a curved object such as a bulged line, an arc, or a spiral.  The The end points will not be affected.  To grab a curve's center point, you must first position the cursor somewhere along the edge (circumference) of the desired element and then press <left mouse> or <Enter>.  The cursor will jump to the center of the curve before the object is lifted from the drawing.\n\n In the event of overlapping targets, curves on the current layer are given preference over those on other layers, and smaller curves are given preference over larger ones.\n\n Items contained within components are accessible only from the proper layer.",
  },
  {
    code: "GX",
    title: "Mirror X",
    tip: "Flip all grabbed cursor attachments along the X axis for a reversed view.",
    body: "The Mirror X function will flip all grabbed cursor attachments along the X axis for a reversed view.  Each time you invoke this function, items attached to the cursor will be mirrored on the X axis using the cursor as the center of translation.  The items will remain in the ghost form until they are released by pressing <left mouse> or <Enter>.\n\n This function is available by simply typing <X> on the keyboard once an item has been grabbed.",
  },
  {
    code: "GY",
    title: "Mirror Y",
    tip: "Flip all grabbed cursor attachments along the Y axis for a reversed view.",
    body: "The Mirror Y function will flip all grabbed cursor attachments along the Y axis for a reversed view.  Each time you invoke this function, items attached to the cursor will be mirrored on the Y axis using the cursor as the center of translation.  The items will remain in the ghost form until they are released by pressing <left mouse> or <Enter>.\n\n This function is available by simply typing <Y> on the keyboard once an item has been grabbed.",
  },
  {
    code: "N-",
    title: "Net Scan -",
    tip: "Scan a data file for routing errors or omissions.",
    body: "This function is used to scan a data file for routing errors or omissions. The nets are searched in descending alphabetical name order until an anomaly is encountered.",
  },
  {
    code: "N+",
    title: "Net Scan +",
    tip: "Scan a data file for routing errors or omissions.",
    body: "This function is used to scan a data file for routing errors or omissions. The nets are searched in ascending alphabetical name order until an anomaly is encountered.",
  },
  {
    code: "NA",
    title: "Auto-route",
    tip: "Convert a ratnest of signals into an orderly set of signal tracks.",
    body: "This function will convert a ratnest of signals into an orderly set of signal tracks.  When you select this function, a dialog box will appear for the specification of the various parameters needed for the routing operation.\n\n Detailed help is available for all items in the dialog box.",
  },
  {
    code: "NC",
    title: "Clear Hilight",
    tip: "Clear and any existing highlight condition and return all hilighted items to their normal display state.",
    body: "This command will clear and any existing highlight condition and return all hilighted items to their normal display state.",
  },
  {
    code: "NG",
    title: "Net Scan Log",
    tip: "Is will scan the entire file for signal interconnections, producing an error log in the form of an interactive report.",
    body: "This function is will scan the entire file for signal interconnections, producing an error log in the form of an interactive report.  The nets will be processed in ascending alphabetical signal name order.\n\n The file must be fully net-listed before this function can be used.  If you have created a circuit board manually without the aid of a schematic or netlist, you may assign net numbers to all un-named nets simply by running the Netlist Out function.\n\n Positioning the cursor on various items within the interactive report will highlight the corresponding objects in the graphics data file.",
  },
  {
    code: "NH",
    title: "Hilight a Net",
    tip: "Illuminate all named pads and tracks in a signal net.",
    body: "The Hilight Net function is used to illuminate all named pads and tracks in a signal net.  Once hilighted, the signal net may be deleted or renamed.",
  },
  {
    code: "NI",
    title: "Netlist In",
    tip: "Read a netlist file from disk and add its component and signal information to the current data file.",
    body: "The Netlist In function is used to read a netlist file from disk and add its component and signal information to the current data file.  All existing signal names will be discarded and will be replaced with those on the designated netlist file.  A log file will be produced with a progress report as well as a listing of any errors that might be encountered in the input stream.\n\n When you select this function, a dialog box will appear for the entry of the desired source netlist file name.  For multi-sheet schematics, multiple netlist files can be processed in a single operation.",
  },
  {
    code: "NL",
    title: "Rat-line",
    tip: "Generate a set of straight line connections for a single signal (net).",
    body: "This function is used to generate a set of straight line connections for a single signal (net).  This is often very useful during manual routing operations.  To use this function, you must first place the cursor over one of the pads in the desired net.  If a signal net already has ratlines, they will be removed.  If the net has no ratlines, a full set will be created.\n\n Like the ratnest function above, this is a \"quick and dirty\" operation that does not actually check for correct or even completed connections.  For that you will need to use one of the Net Scan functions.",
  },
  {
    code: "NM",
    title: "Net Image",
    tip: "Display a pixel image associated with the highlighted signal net.",
    body: "This function will display a pixel image associated with the highlighted signal net.  This may be an oscillograph image or any other file carrying the name of the target signal and located in the same directory as the main data file.",
  },
  {
    code: "NN",
    title: "Name Net",
    tip: "Invoke a dialog box for the entry of a new signal name to be applied to all hilighted pads and tracks.",
    body: "This function will invoke a dialog box for the entry of a new signal name to be applied to all hilighted pads and tracks.",
  },
  {
    code: "NO",
    title: "Netlist Out",
    tip: "Write out the component and signal information from the current data file to disk in the form of a netlist.",
    body: "The Netlist Out function is used to write out the component and signal information from the current data file to disk in the form of a netlist. The file will be scanned for un-named signals and sequential numbers will be assigned to those signals.\n\n When you select this function, a dialog box will appear for the entry of the desired destination netlist file name.  The default file name is the same as the source file with a .NET suffix.  If the source file name contains a numeric suffix (such as .SH1), that number will be preserved in the output file suffix (i.e. .SH1 to .NT1).",
  },
  {
    code: "NR",
    title: "Rat-nest",
    tip: "Generate a set of straight line connections needed to complete the routing of a circuit board.",
    body: "This function is used to generate a set of straight line connections needed to complete the routing of a circuit board.  A ratnest is a necessary part of the auto-routing function.  A ratnest is also indispensable for routing boards manually, giving you a ready guide as to which pins need tracks between them.  After you have routed a number of tracks, you may simply ratnest again to get a fresh look at the routing that remains to be done.\n\n The ratnest function is a \"quick and dirty\" operation that does not actually check for correct or even completed connections.  For that you will need to use one of the Net Scan functions.",
  },
  {
    code: "NS",
    title: "Net Scan",
    tip: "\"sniff out\" and illuminate all tracks, pads, and vias along a signal pathway.",
    body: "The Net Scan command is used to \"sniff out\" and illuminate all tracks, pads, and vias along a signal pathway.  To scan a signal net, you must first position the cursor somewhere along the desired signal and then press <left mouse> or <Enter>.  The target line segment is first hilighted, then, recursively, each line segment, pad or via that it is in electrical contact with.  Ratlines will be constructed for any missing segments in the net.  The scan operation will terminate if any cross-linked pins are encountered.",
  },
  {
    code: "NT",
    title: "Rat-nest Signals Only",
    tip: "Generate a set of straight line connections for all signals other than power and ground.",
    body: "This function is used to generate a set of straight line connections for all signals other than power and ground.  This is often very useful during the component placement phase of a new circuit board, since it shows all active signals but does not clutter up the screen with low information content power lines, which in general go to almost every part anyhow.  The signals will be omitted from the ratnest operation if they carry any of the following names:\n1: GND\n2: PWR\n3: VCC\n4: VSS\n5: VDD\n6: +?V (where ? represents any numeric value)\n7: -?V (where ? represents any numeric value)\n\nLike the ratnest function above, this is a \"quick and dirty\" operation that does not actually check for correct or even completed connections.  For that you will need to use one of the Net Scan functions.",
  },
  {
    code: "NU",
    title: "Un-ratnest",
    tip: "Clear and remove all lines and arcs from the Ratnest layer.",
    body: "This function will clear and remove all lines and arcs from the Ratnest layer.",
  },
  {
    code: "P-",
    title: "Place Rat-line",
    tip: "Construct a rat-line between any two pads.",
    body: "The Place Rat-line function is used to construct a rat-line between any two pads.  When you click on the first point in a group of points, a dialog box will appear which will allow you to enter the target signal name.\n\n The cursor may be automatically snapped to the exact center of each target pad by invoking the Query Items dialog box, enabling the \"Pads\" selection, and checking the \"Snap to center\" box.",
  },
  {
    code: "P+",
    title: "Place +/- Port",
    tip: "Create and name a positive or negative power or voltage port.",
    body: "The Place +/- Port function is used to create and name a positive or negative power or voltage port.\n\n The power port that is created is actually a special case of a component. Once placed, it can be moved or deleted by using any of the standard component functions.",
  },
  {
    code: "PA",
    title: "Place Arc",
    tip: "Create a partial or complete circular or elliptical arc.",
    body: "The Place Arc/circle/ellipse function is used to create a partial or complete circular or elliptical arc.  When you select this function, a dialog box will appear which will allow you to enter the several parameters needed for the construction of the desired arc.\n\n The default arc placement parameters are re-loaded each time you edit an existing arc.",
  },
  {
    code: "PB",
    title: "Place Bus Port",
    tip: "Create and name a signal port to be connected to a signal bus.",
    body: "The Place Bus Port function is used to create and name a signal port to be connected to a signal bus.\n\n The bus port that is created is actually a special case of a component. Once placed, it can be moved or deleted by using any of the standard component functions.",
  },
  {
    code: "PC",
    title: "Place Component",
    tip: "Fetch a component from the symbols library.",
    body: "The Place Component function is used to fetch a component from the symbols library.  Each time you use this function, a dialog box will appear which will allow you to enter the several parameters needed to define the desired component.  A component search engine will be available if you do not know the exact name of the desired component's pattern.\n\n The default component placement parameters are re-loaded each time you edit an existing component.",
  },
  {
    code: "PD",
    title: "Place Signal Dot",
    tip: "Create a 40-mil diameter surface-via on the signals layer of a schematic drawing.",
    body: "The Place Signal Dot function is used to create a 40-mil diameter surface-via on the signals layer of a schematic drawing.\n\n Once they have been placed, the signal dots can be moved, edited, or deleted by using any of the pad functions.",
  },
  {
    code: "PE",
    title: "Place Vertex",
    tip: "Add a vertex to the interior of an existing line segment.",
    body: "The Place Vertex function is used to add a vertex to the interior of an existing line segment.  To use this function, the cursor must be located within the body of the desired source line segment.\n\n No dialog boxes are used by this function.",
  },
  {
    code: "PF",
    title: "Place Filled Solid",
    tip: "Create a polygon region.",
    body: "The Place Filled Solid function is used to create a polygon region.  The region can be of any arbitrary shape, and can be placed on any target layer. When you select this function, a dialog box will appear which will allow you to enter an assortment of parameters and creation modes for the new filled region.\n\n After confirming on the parameters box, you will be prompted to enter a sequence of vertex points.  After selecting a minimum of three data points, the function will be completed by pressing <right mouse> or <Escape>.",
  },
  {
    code: "PG",
    title: "Place Signal GND",
    tip: "Create a normal ground port to be connected to a ground plane or ground bus.",
    body: "The Place Signal GND function is used to create a normal ground port to be connected to a ground plane or ground bus.  The signal will automatically be given a net name of GND.\n\n The ground port that is created is actually a special case of a component. Once placed, it can be moved or deleted by using any of the standard component functions.",
  },
  {
    code: "PH",
    title: "Place Earth GND",
    tip: "Create a forked symbol to be used as a chassis or earth ground port.",
    body: "The Place Earth GND function is used to create a forked symbol to be used as a chassis or earth ground port.  The signal will automatically be given a net name of EARTH.\n\n The ground port that is created is actually a special case of a component. Once placed, it can be moved or deleted by using any of the standard component functions.",
  },
  {
    code: "PI",
    title: "Place Bus Wire",
    tip: "Create a 50-mil thick ortho-line on the busses layer of a schematic drawing.",
    body: "The Place Bus Wire function is used to create a 50-mil thick ortho-line on the busses layer of a schematic drawing.\n\n Once they have been placed, the bus wires can be moved, edited, or deleted by using any of the line functions.",
  },
  {
    code: "PJ",
    title: "Place Spiral",
    tip: "Create a spiral of up to one full turn.",
    body: "The Place Spiral function is used to create a spiral of up to one full turn.  When you select this function, a dialog box will appear which will allow you to enter the several parameters needed for the construction of the desired spiral.\n\n The default spiral placement parameters are re-loaded each time you edit an existing spiral.",
  },
  {
    code: "PK",
    title: "Pick Component",
    tip: "Fetch components from the symbols library.",
    body: "The Pick Component function is used to fetch components from the symbols library.  When you invoke this function, a persistent dialog box will appear containing the source libraries for this data file.  A component may be selected for placement by simply clicking on its picture.",
  },
  {
    code: "PL",
    title: "Place Line",
    tip: "Construct a straight line segment between any two points.",
    body: "The Place Line function is used to construct a straight line segment between any two points.  When you select this function, a dialog box will appear which will allow you to to enter the destination layer, line width, drawing style, and an optional special color.\n\n The default line placement parameters are re-loaded each time you edit an existing line segment.",
  },
  {
    code: "PM",
    title: "Place Named GND",
    tip: "Create a triangular symbol to be used as a logic or analog ground port.",
    body: "The Place Named GND function is used to create a triangular symbol to be used as a logic or analog ground port.  The port may be attached to any desired signal net.\n\n The ground port that is created is actually a special case of a component. Once placed, it can be moved or deleted by using any of the standard component functions.",
  },
  {
    code: "PN",
    title: "Place Signal Name",
    tip: "Attach a name to a signal wire.",
    body: "The Place Signal Name function is used to attach a name to a signal wire. The signal name will be transmitted from the schematic to the PCB through the netlist file.\n\n Once they have been placed, the signal names can be moved, edited, or deleted by using any of the text functions.",
  },
  {
    code: "PO",
    title: "Place Ortho-line",
    tip: "Construct a line segment that is constrained to follow one of the four cardinal directions and their four diagonals.",
    body: "The Place Ortho-line function is used to construct a line segment that is constrained to follow one of the four cardinal directions and their four diagonals.  When you select this function, a dialog box will appear which will allow you to to enter the destination layer, line width, drawing style, and an optional special color.\n\n The default line placement parameters are re-loaded each time you edit an existing line segment.",
  },
  {
    code: "PP",
    title: "Place Pad",
    tip: "Create a pad, a via, or a mounting hole.",
    body: "The Place Pad function is used to create a pad, a via, or a mounting hole. When you select this function, a dialog box will appear which will allow you to enter the several parameters needed for the construction of the desired pad.\n\n The default pad placement parameters are re-loaded each time you edit an existing pad.",
  },
  {
    code: "PR",
    title: "Place Arrowhead",
    tip: "Create an arrowhead for labeling purposes.",
    body: "The Place Arrowhead function will create an arrowhead for labeling purposes. No dialog boxes will be invoked.",
  },
  {
    code: "PS",
    title: "Place Signal Port",
    tip: "Create and name a signal port to be connected to other sheets or other places on the same sheet.",
    body: "The Place Signal Port function is used to create and name a signal port to be connected to other sheets or other places on the same sheet.\n\n The signal port that is created is actually a special case of a component. Once placed, it can be moved or deleted by using any of the standard component functions.",
  },
  {
    code: "PT",
    title: "Place Text",
    tip: "Create an ASCII text string for labeling purposes.",
    body: "The Place Text function is used to create an ASCII text string for labeling purposes.  When you select this function, a dialog box will appear which will allow you to enter the destination layer, text size, and rotational angle.\n\n The default text placement parameters are re-loaded each time you edit an existing text string.",
  },
  {
    code: "PU",
    title: "Build Component",
    tip: "The Build Component function may be used to create new components and optionally insert them into one of the existing source library files.",
    body: "The Build Component function may be used to create new components and optionally insert them into one of the existing source library files. When you select this function, a dialog box will appear which will allow you to enter the several parameters needed to properly describe the new component.\n\n Additional help is available for all items in the dialog box.",
  },
  {
    code: "PV",
    title: "Place Via",
    tip: "Create a connecting via at the junction of two line segments.",
    body: "The Place Via function is used to create a connecting via at the junction of two line segments.  No dialog boxes will be invoked.\n\n The default parameters used to create the via may be modified from the \"Defaults\" tab of the \"Setup Parameters\" function.",
  },
  {
    code: "PW",
    title: "Place Signal Wire",
    tip: "Create a 10-mil thick ortho-line on the signals layer of a schematic drawing.",
    body: "The Place Signal Wire function is used to create a 10-mil thick ortho-line on the signals layer of a schematic drawing.\n\n Once they have been placed, the signal wires can be moved, edited, or deleted by using any of the line functions.",
  },
  {
    code: "PX",
    title: "Place XY Dimension",
    tip: "Create a resizable dimension line for labeling purposes.",
    body: "The Place XY Dimension function will create a resizable dimension line for labeling purposes.  No dialog boxes will be invoked.\n\n The default parameters used to create the dimension line may be modified from the \"Defaults\" tab of the \"Setup Parameters\" function.",
  },
  {
    code: "PY",
    title: "Place Arc Graphically",
    tip: "Create an arc with the graphics editor using only the mouse for selecting the data points.",
    body: "This function will create an arc with the graphics editor using only the mouse for selecting the data points.  When you select this function, you will be prompted (in sequence) for a center point, a start point, and a completion point.",
  },
  {
    code: "PZ",
    title: "Place Spiral Graphically",
    tip: "Create a spiral with the graphics editor using only the mouse for selecting the data points.",
    body: "This function will create a spiral with the graphics editor using only the mouse for selecting the data points.  When you select this function, you will be prompted (in sequence) for a center point, a start point, and a end point.",
  },
  {
    code: "SA",
    title: "Administrator Parameters",
    tip: "A multi-sheet tabbed dialog box with controls for special parameters that are accessible only the Systems Administrator.",
    body: "This function invokes a multi-sheet tabbed dialog box with controls for special parameters that are accessible only the Systems Administrator.\n\n Detailed help is available for all items in the dialog box.",
  },
  {
    code: "Sc",
    title: "Library Management",
    tip: "Dialog box which will allow you to add or delete components from the various source library files.",
    body: "This function invokes dialog box which will allow you to add or delete components from the various source library files.\n\n Detailed help is available for all items in the dialog box.",
  },
  {
    code: "SC",
    title: "Component Parameters",
    tip: "A dialog box which will allow you modify the names of the various component parameters.",
    body: "This selection invokes a dialog box which will allow you modify the names of the various component parameters.  Internally, the component parameters are processed by their sequential number, and the names are simply added on top for easy access.",
  },
  {
    code: "SF",
    title: "Library Files",
    tip: "Dialog box which will allow you to modify the set of source library files that are accessible from this data file.",
    body: "This function invokes dialog box which will allow you to modify the set of source library files that are accessible from this data file.",
  },
  {
    code: "SG",
    title: "Grid Snaps",
    tip: "A dialog box which will allow you set a new grid snap value.",
    body: "This selection invokes a dialog box which will allow you set a new grid snap value.  You may either enter a new value or select an existing value from the predefined table of grid snaps.  You may also add, delete, or modify entries in the table.\n\n The grid snap table is also accessible from a \"context\" menu invoked by right-clicking on the Grid Snap setting in the Status Bar at the bottom of the data window.  Alternatively, you may sequentially step through the grid snap table by typing <Alt G> on the keyboard.",
  },
  {
    code: "SK",
    title: "Keystroke Macros",
    tip: "A dialog box which will allow you to examine (and modify) the operations that are performed by the function keys on the keyboard.",
    body: "This selection invokes a dialog box which will allow you to examine (and modify) the operations that are performed by the function keys on the keyboard.",
  },
  {
    code: "SL",
    title: "Layer Table",
    tip: "A dialog box which will allow you to control all parameters specific to individual layers of the data file.",
    body: "The Setup Layers function invokes a dialog box which will allow you to control all parameters specific to individual layers of the data file.",
  },
  {
    code: "SM",
    title: "File Parameters",
    tip: "A multi-sheet tabbed dialog box with controls for all setup parameters specific to this data file.",
    body: "This function invokes a multi-sheet tabbed dialog box with controls for all setup parameters specific to this data file.\n\n Detailed help is available for all items in the dialog box.",
  },
  {
    code: "SO",
    title: "System Parameters",
    tip: "A multi-sheet tabbed dialog box with controls for all global parameters that are not specific to an individual data file.",
    body: "This function invokes a multi-sheet tabbed dialog box with controls for all global parameters that are not specific to an individual data file.\n\n Detailed help is available for all items in the dialog box.",
  },
  {
    code: "Sp",
    title: "Printer Font",
    tip: "Invokes a dialog box allowing you to select the font used when printing a document.",
    body: "Invokes a dialog box allowing you to select the font used when printing a document.",
  },
  {
    code: "SP",
    title: "Zero Point",
    tip: "Alternatively set or clear the zero reference point that is used for the screen coordinate system.",
    body: "This function will alternatively set or clear the zero reference point that is used for the screen coordinate system.  This value is also used as the zero point for Gerber output files.  If relative addressing is already in effect, this function will restore absolute addressing. An audible report is produced when relative addressing is engaged.\n\n The status bar will display a <Z> when a relative zero point is in effect.\n\n This function is available by simply typing <Alt R> on the keyboard.",
  },
  {
    code: "Ss",
    title: "Screen Font",
    tip: "Invokes a dialog box allowing you to select the font used to draw text onto the display screen.",
    body: "Invokes a dialog box allowing you to select the font used to draw text onto the display screen.",
  },
  {
    code: "ST",
    title: "Ortho Mode",
    tip: "In addition to an XY grid snap system, the graphics cursor can be constrained to move only along a set orthogonal axis from its local…",
    body: "In addition to an XY grid snap system, the graphics cursor can be constrained to move only along a set orthogonal axis from its local starting point.  Ortho-snap mode is observed by the place line and place vertex functions, and by all of the grab functions.  There are four ortho-snap modes available, and this function lets you sequentially step from one mode to the next.\n\n Mode 0:  No angular cursor constraints in effect.\nMode 1:  Vertical and horizontal cursor motion only.\nMode 2:  Diagonal cursor motion only.\nMode 3:  Vertical, horizontal, and diagonal cursor motion.\n\nThe status bar will display the current ortho-snap mode as a dot, a plus, an x, or an asterisk.\n\n This function is available by simply typing <T> on the keyboard.",
  },
  {
    code: "SU",
    title: "User Preferences",
    tip: "A simple two-column dialog box showing all user settable parameters (in alphabetical order) along with their assigned values.",
    body: "This function invokes a simple two-column dialog box showing all user settable parameters (in alphabetical order) along with their assigned values. Many of the parameters are for internal use only and some of them are a bit esoteric. No detailed information is provided within this operation.\n\n Although not recommended, you may also modify any of the various parameters once they have been selected.  The setting of invalid or improper values may inhibit SirCAD from proper operation.\n\nMenu 0x5380 Central Quarter Page Resize and move this window to the central quarter of the display screen.\n\n When in \"text\" mode, this function is available by simply typing <Ctl-F5> on the keyboard.\n\nMenu 0x5381 Left Half Page Resize and move this window to the left half of the display screen.\n\n When in \"text\" mode, this function is available by simply typing <Ctl-F2> on the keyboard.\n\nMenu 0x5382 Right Half Page Resize and move this window to the right half of the display screen.\n\n When in \"text\" mode, this function is available by simply typing <Ctl-F3> on the keyboard.\n\nMenu 0x5383 Dual Left/Right Pages Resize and move this window to the left half of the display screen.  Then resize and move a sibling window to the right half of the display screen. If there is no sibling window open, create one and move it to the right half of the display screen.\n\n When in \"text\" mode, this function is available by simply typing <Ctl-F4> on the keyboard.\n\nMenu 0x5384 Full Page Resize this window to fill the entire display screen.\n\n When in \"text\" mode, this function is available by simply typing <Ctl-F1> on the keyboard.\n\nMenu 0x5385 Top Half Page Resize and move this window to the top half of the display screen.\n\n When in \"text\" mode, this function is available by simply typing <Ctl-F6> on the keyboard.\n\nMenu 0x5386 Bottom Half Page Resize and move this window to the bottom half of the display screen.\n\n When in \"text\" mode, tThis function is available by simply typing <Ctl-F7> on the keyboard.\n\nMenu 0x5387 Dual Top/Bottom Pages Resize and move this window to the top half of the display screen.  Then resize and move a sibling window to the bottom half of the display screen. If there is no sibling window open, create one and move it to the bottom half of the display screen.\n\n When in \"text\" mode, this function is available by simply typing <Ctl-F8> on the keyboard.",
  },
  {
    code: "Sw",
    title: "Mouse Wheel",
    tip: "Invokes a dialog box allowing you to set the \"gain\" of the mouse wheel when used to vertically scroll a text data file.",
    body: "Invokes a dialog box allowing you to set the \"gain\" of the mouse wheel when used to vertically scroll a text data file.",
  },
  {
    code: "SW",
    title: "Mirror View",
    tip: "Flip an entire data file along the X axis to view it from the opposite side of the board.",
    body: "This function is used to flip an entire data file along the X axis to view it from the opposite side of the board.  This is useful as a quick check of various mirrored data structures such as bottom side components and text.\n\n This function is available by simply typing <Alt V> on the keyboard.",
  },
  {
    code: "Sx",
    title: "Shell Execute",
    tip: "Invokes a dialog box allowing you to associate data processing programs with assorted source file types.",
    body: "Invokes a dialog box allowing you to associate data processing programs with assorted source file types.  The individual data file types are identified by their file name suffix.\n\n Detailed help is available for all items in the dialog box.",
  },
  {
    code: "UA",
    title: "Un-Do All",
    tip: "Un-Do all operations since the last time the Un-Do stack was purged.",
    body: "This function will Un-Do all operations since the last time the Un-Do stack was purged.  Under normal conditions, the Un-Do stack is purged only when a file is written to disk.",
  },
  {
    code: "UE",
    title: "Re-Do All",
    tip: "Re-Do all operations that have been undone since the last time the Re-Do stack was purged.",
    body: "This function will Re-Do all operations that have been undone since the last time the Re-Do stack was purged.  All redone data is placed back into the Un-Do stack.",
  },
  {
    code: "UP",
    title: "Purge Re-Do Stack",
    tip: "Clear the Re-Do stack, making it impossible to Re-Do any of the operations that have been undone.",
    body: "This function will clear the Re-Do stack, making it impossible to Re-Do any of the operations that have been undone.  Normally this is done automatically any time an operation is performed that itself has the option of being undone.",
  },
  {
    code: "UR",
    title: "Re-Do Event",
    tip: "Re-Do the most recent Un-Do operation, so long as there have been no intervening operations that require undoing themselves.",
    body: "This function will Re-Do the most recent Un-Do operation, so long as there have been no intervening operations that require undoing themselves. As an operation is \"redone\" its data in placed back into the Un-Do stack.\n\n This function is available by simply typing <Alt-*> on the numeric keypad.",
  },
  {
    code: "US",
    title: "Purge Un-Do Stack",
    tip: "Clear the Un-Do stack, making it impossible to accidentally Un-Do any of the previous operations.",
    body: "This function will clear the Un-Do stack, making it impossible to accidentally Un-Do any of the previous operations.  Normally this is done automatically when a file is saved to disk.",
  },
  {
    code: "UU",
    title: "Un-Do Event",
    tip: "Un-do the most recent operation, whether that be the placement of a new object, the deletion of an existing object, or the moving of an…",
    body: "This function will un-do the most recent operation, whether that be the placement of a new object, the deletion of an existing object, or the moving of an object to a new position in the file.  As an operation is \"undone\" its data in placed into a Re-Do stack so that you can immediately Un-Do the Un-Do function if you should happen to Un-Do too far.  The Re-Do stack will be cleared the first time you perform another operation that can be undone.\n\n This function is available by simply typing <*> on the numeric keypad.",
  },
  {
    code: "ZA",
    title: "Zoom Absolute",
    tip: "Resize the file such that the selected pixel array will have a 1:1 mapping with the display screen.",
    body: "The Zoom Absolute function will resize the file such that the selected pixel array will have a 1:1 mapping with the display screen.",
  },
  {
    code: "ZB",
    title: "Zoom Board",
    tip: "Compute and install the optimum scaling factor such that all user generated line segments will be visible at one time at the largest…",
    body: "This function will compute and install the optimum scaling factor such that all user generated line segments will be visible at one time at the largest magnification possible.  Normally, the maximum data extents in the file will be the outline of the circuit board.",
  },
  {
    code: "ZC",
    title: "Zoom Center",
    tip: "Move the desired viewpoint to the center of the display screen without changing the magnification factor.",
    body: "This function will move the desired viewpoint to the center of the display screen without changing the magnification factor.",
  },
  {
    code: "Zi",
    title: "Zoom In",
    tip: "Enlarges the screen font size by one step.",
    body: "Enlarges the screen font size by one step.\n\n This function is available by simply typing <Alt-I> on the keyboard.",
  },
  {
    code: "ZI",
    title: "Zoom In",
    tip: "Magnify the image of the data file, yielding a smaller field of view at a greater resolution.",
    body: "The Zoom In function is used to magnify the image of the data file, yielding a smaller field of view at a greater resolution.  The scale of the zoom may be set through the Zoom Factors tab of the Setup Options function.\n\n This function is available by simply typing <I> on the keyboard.",
  },
  {
    code: "ZK",
    title: "Zoom Block",
    tip: "Compute and install the optimum scaling factor such that entire containment block will be visible at one time at the largest…",
    body: "This function will compute and install the optimum scaling factor such that entire containment block will be visible at one time at the largest magnification possible.  If no block is defined, this function will default to a \"Zoom Extents\".",
  },
  {
    code: "ZL",
    title: "Zoom Layer",
    tip: "Select a new active layer to be used for viewing and editing.",
    body: "This function is used to select a new active layer to be used for viewing and editing.  When you select this function, a dialog box will appear containing a list of available layers.  The current layer will be identified by shading.  When a new layer is selected, that single layer is regenerated so as to be prominently displayed on the screen.\n\n The individual layers can also be selected sequentially by using the <+> and <-> keys on the numeric key pad.",
  },
  {
    code: "Zo",
    title: "Zoom Out",
    tip: "Shrinks the screen font size by one step.",
    body: "Shrinks the screen font size by one step.\n\n This function is available by simply typing <Alt-O> on the keyboard.",
  },
  {
    code: "ZO",
    title: "Zoom Out",
    tip: "Demagnify the image of the data file, yielding a larger field of view at a lesser resolution.",
    body: "The Zoom Out function is used to demagnify the image of the data file, yielding a larger field of view at a lesser resolution.  The scale of the zoom may be set through the Zoom Factors tab of the Setup Options function.\n\n This function is available by simply typing <O> on the keyboard.",
  },
  {
    code: "ZR",
    title: "Zoom Redraw",
    tip: "Re-generate the display screen without changing the magnification factor or viewpoint.",
    body: "This function is used to re-generate the display screen without changing the magnification factor or viewpoint.",
  },
  {
    code: "Zs",
    title: "Zoom Save",
    tip: "Saves the current screen font size and type face as the new default value for all text files.",
    body: "Saves the current screen font size and type face as the new default value for all text files.",
  },
  {
    code: "ZS",
    title: "Zoom Scale",
    tip: "Invoke a dialog box for the entry of the desired zoom factor.",
    body: "The Zoom Scale function will invoke a dialog box for the entry of the desired zoom factor.",
  },
  {
    code: "ZW",
    title: "Zoom Window",
    tip: "Define a specific rectangular region of the data file and display it at maximum size on the screen.",
    body: "This function allows you to define a specific rectangular region of the data file and display it at maximum size on the screen.",
  },
  {
    code: "ZX",
    title: "Zoom Extents",
    tip: "Compute and install the optimum scaling factor such that all file elements will be visible at one time at the largest magnification…",
    body: "This function will compute and install the optimum scaling factor such that all file elements will be visible at one time at the largest magnification possible.",
  },
  {
    code: "ZY",
    title: "Zoom Layer Only",
    tip: "Display the current layer only, with all other layers effectively \"turned off\".",
    body: "This function is used to display the current layer only, with all other layers effectively \"turned off\".  The display may be returned to normal by selecting \"Zoom Redraw\" above.",
  },
];

/** Help for one command code, or undefined. */
export function helpFor(code: string): HelpTopic | undefined {
  return HELP_TOPICS.find((t) => t.code === code);
}
